import { useEffect, useMemo, useState } from 'react';

function pad(n) {
  return n.toString().padStart(2, '0');
}

function useCountdown(targetMs) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!targetMs) {
      // Always return a cleanup to satisfy ESLint
      return () => {};
    }

    let timer;

    // drift-aware ticking: schedule next tick exactly on the second
    const tick = () => {
      const next = Date.now();
      setNow(next);
      const remainder = 1000 - (next % 1000);
      timer = window.setTimeout(tick, remainder);
    };

    timer = window.setTimeout(tick, 1000 - (Date.now() % 1000));

    return () => {
      if (timer) {
        window.clearTimeout(timer);
      }
    };
  }, [targetMs]);

  const remaining = useMemo(() => {
    if (!targetMs) return 0;
    return Math.max(0, targetMs - now);
  }, [targetMs, now]);

  const isOver = remaining === 0;

  const hours = Math.floor(remaining / 3600000);
  const minutes = Math.floor((remaining % 3600000) / 60000);
  const seconds = Math.floor((remaining % 60000) / 1000);

  return {
    isOver,
    hours,
    minutes,
    seconds,
    hh: pad(hours),
    mm: pad(minutes),
    ss: pad(seconds),
  };
}

export default useCountdown;
